import { truncateAccessibleName } from '../ask-chip';

interface AskChipLegacyProps {
  label: string;
  action: string;
  onClick: () => void;
}

/**
 * FRONT-3223: the ask chip as on `origin/main`, for the `eddy.ui-refactoring`
 * OFF path. The one thing blocking EDDY, spelled out inline (README §3) —
 * rendered only when at least one chat OR Building Session (FRONT-1681) is
 * `asking`. Amber border and tint, a blinking dot, and the action word
 * printed — all of which the reworked chip (`../ask-chip.tsx`) dropped.
 */
export function AskChipLegacy({ label, action, onClick }: AskChipLegacyProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={truncateAccessibleName(`${action}: ${label}`)}
      className="inline-flex h-[38px] max-w-[360px] min-w-0 items-center gap-[8px] overflow-hidden rounded-[11px] border border-amber-500/25 bg-amber-500/10 pr-[12px] pl-[11px] whitespace-nowrap"
    >
      <span className="eddy-tb-blink size-[7px] shrink-0 rounded-full bg-amber-500" />
      <span className="min-w-0 flex-1 truncate text-left text-[13px] text-[var(--ink-0)]">
        {label}
      </span>
      <span className="shrink-0 text-[13px] font-medium text-amber-600 dark:text-amber-400">
        {action}
      </span>
    </button>
  );
}
